export default "__VITE_ASSET__EELnJZcE__"